import $ from 'jquery';

const initQuoteParallax = (el) => {
  const $this = $(el);

  $(window).on('scroll', () => {
    const height = $this.outerHeight();
    const vh = $(window).outerHeight();
    const scrollTop = $(window).scrollTop();
    const quoteOffset = $this.offset().top;
    const coordinateY = quoteOffset - scrollTop;
    const horizon = (vh / 5) * 2;

    if (coordinateY < horizon && coordinateY + height >= horizon) {
      $this.addClass('visible');
    } else {
      $this.removeClass('visible');
    }
  });
};

// eslint-disable-next-line func-names
(function (window, Drupal) {
  Drupal.behaviors.mstQuoteParallax = {
    attach(context) {
      $('.quote-parallax', context).each((index, element) => initQuoteParallax(element));
    },
  };
}(window, Drupal));
